export default {
  assetDocumentation: 'Dokumentacja aktywów',
  noAssetBlobs: 'Asset {asset} nie posiada dokumentacji.',
  overheadTime: 'Czas narzutu',
  engineerNote: 'Osoba przypisana',
  managerFeedback: 'Menedżer',
  deleteLastEventMessage: 'Zamierzasz Usunąć ostatnie wydarzenie w serii.\nSpowoduje to usunięcie całej serii.\n{text}',
  inProgressStateWarning: 'Proszę oznaczyć zadania jako ukończone lub pominięte. Jeśli któreś z zadań jest pominięte, proszę zostawić komentarz dla każdego pominiętego zadania.',
  inReviewStateWarning: 'Aby oznaczyć wydarzenie jako "Zakończone", wszystkie zadania muszą być oznaczone jako "Zaakceptowane"',
};
